const positionsApi = '/positions';

export const applyPosition = () => `${positionsApi}/apply`;
export const resetPositionAPI = () => `${positionsApi}/reset`;
